import { z } from 'zod';
import { I18nStringSchema } from '../core/i18n';
export const ObservationIconSchema = z.object({
    _id: z.string(),
    altText: I18nStringSchema,
    imageURL: z.string()
});
//# sourceMappingURL=observation.js.map